import React, { useState } from 'react';
import './Aboutsect1.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import img1 from '../Components/Images/About/1.webp'
import img3 from '../Components/Images/About/2.webp'
import img2 from '../Components/Images/About/3.jpg'
import img4 from '../Components/Images/About/4.jpeg'


function Aboutsect1() {
  const [activeTab, setActiveTab] = useState('whatWeDo');
  
  // Function to handle tab click
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="about-section">
      <section className="tabs-section py-5" id="tabs">
        <div className="container py-lg-5 py-md-4 py-2">
          <div className="section-header text-center mb-5">
            <span className="subtitle">We Provide</span>
            <h2 className="section-title text-center">
              Specialization in Developing <br/>Business Strategy
            </h2>
          </div>
          
          <div className="tabs-container">
            {/* Modern Tab Navigation */}
            <div className="tabs-navigation">
              <ul className="nav-tabs-custom">
                <li 
                  className={`tab-item ${activeTab === 'whatWeDo' ? 'active' : ''}`}
                  onClick={() => handleTabClick('whatWeDo')}
                >
                  <span className="tab-icon">
                    <i className="fas fa-briefcase"></i>
                  </span>
                  <span className="tab-label">What we do</span>
                </li>
                <li 
                  className={`tab-item ${activeTab === 'mission' ? 'active' : ''}`}
                  onClick={() => handleTabClick('mission')}
                >
                  <span className="tab-icon">
                    <i className="fas fa-bullseye"></i>
                  </span>
                  <span className="tab-label">Our Mission</span>
                </li>
                <li 
                  className={`tab-item ${activeTab === 'social' ? 'active' : ''}`}
                  onClick={() => handleTabClick('social')}
                >
                  <span className="tab-icon">
                    <i className="fas fa-users"></i>
                  </span>
                  <span className="tab-label">Social Impact</span>
                </li>
                <li 
                  className={`tab-item ${activeTab === 'marketing' ? 'active' : ''}`}
                  onClick={() => handleTabClick('marketing')}
                >
                  <span className="tab-icon">
                    <i className="fas fa-chart-line"></i>
                  </span>
                  <span className="tab-label">Marketing</span>
                </li>
              </ul>
            </div>
            
            {/* Tab Content Area */}
            <div className="tab-content-container">
              {/* What we do tab */}
              <div className={`tab-content-panel ${activeTab === 'whatWeDo' ? 'active' : ''}`}>
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="content-box">
                    <h3 className="tab-heading">Smart Retail & Security Solutions in Bahrain</h3>
                        <p className="tab-text">
                          At Zartec Solutions, we provide cutting-edge retail technology and security systems tailored for supermarkets, apparel stores, industrial warehouses, and more. As authorized dealers of SUNMI, we empower businesses with smart POS systems, RFID, and EAS security installations.
                        </p>
                        <ul className="feature-list">
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Authorized dealer of SUNMI POS solutions</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Advanced EAS and RFID security systems</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Barcode printers, labels & accessories</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Custom retail technology consultation</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Professional installation and support</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Solutions for food packaging & apparel industries</li>
                        </ul>

                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="image-container">
                      <img src={img1} className="tab-image" alt="Business Team" />
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Our Mission tab */}
              <div className={`tab-content-panel ${activeTab === 'mission' ? 'active' : ''}`}>
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="image-container">
                      <img src={img2} className="tab-image" alt="Our Mission" />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="content-box">
                    <h3 className="tab-heading">Empowering Retailers with Reliable Tech</h3>
                        <p className="tab-text">
                          Our mission is to deliver reliable, affordable, and scalable technology to businesses in Bahrain. We aim to transform how retail and industry operate through smart automation, secure transactions, and professional support.
                        </p>
                        <ul className="feature-list align-left">
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Drive retail automation and digital transformation</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Enhance operational efficiency, customer satisfaction</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Offer technology that fits every scale and budget</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Build lasting partnerships through support and trust</li>
                        </ul>

                    </div>
                  </div>
                </div>
              </div>
              
              {/* Social impact tab */}
              <div className={`tab-content-panel ${activeTab === 'social' ? 'active' : ''}`}>
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="content-box">
                    <h3 className="tab-heading">Supporting Businesses in Bahrain’s Growth</h3>
                      <p className="tab-text">
                        Zartec Solutions believes in uplifting local businesses by offering world-class technology at competitive prices. Our solutions help entrepreneurs, SMEs, and industries grow faster and smarter, contributing to Bahrain’s economic vision.
                      </p>
                      <ul className="feature-list">
                        <li><span className="check-icon"><i className="fas fa-check"></i></span>Support for startups and local retailers</li>
                        <li><span className="check-icon"><i className="fas fa-check"></i></span>Contributing to a tech-enabled Bahrain</li>
                        <li><span className="check-icon"><i className="fas fa-check"></i></span>Training and support for client empowerment</li>
                        <li><span className="check-icon"><i className="fas fa-check"></i></span>Localized services and in-country support</li>
                      </ul>

                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="image-container">
                      <img src={img3} className="tab-image" alt="Social Impact" />
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Marketing tab */}
              <div className={`tab-content-panel ${activeTab === 'marketing' ? 'active' : ''}`}>
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="image-container">
                      <img src={img4} className="tab-image" alt="Marketing" />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="content-box">
                    <h3 className="tab-heading">Helping You Market Smarter</h3>
                        <p className="tab-text">
                          Zartec doesn’t just provide hardware—we help you create a seamless customer experience. From digital POS displays to real-time data collection via our smart systems, we help you grow your visibility and engagement.
                        </p>
                        <ul className="feature-list">
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>POS solutions with customer insights</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Easy integration with loyalty and inventory systems</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Boost brand perception with sleek tech</li>
                          <li><span className="check-icon"><i className="fas fa-check"></i></span>Data-driven tools for smarter marketing</li>
                        </ul>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Aboutsect1;